/** Display context only. Every mutation still uses the real authenticated actor. */
export function orderViewRoles(actual: string[] = [], requested?: string | null): string[] {
  if (!actual.length) return []
  if (requested && actual.includes(requested)) return [requested]
  return [...new Set(actual)]
}

/** 详情只切换本人具有的办理角色；管理员权限不等于拥有所有部门角色。 */
export function orderDetailRoleContext(actual: string[] = [], requested?: string | null) {
  const actualRoles = [...new Set(actual)]
  const switchRoles = ['ADMIN', 'MARKET', 'SERVICE', 'FINANCE'].filter(role => actualRoles.includes(role))
  const role = requested && actualRoles.includes(requested)
    ? requested
    : switchRoles[0] || (actualRoles.length === 1 ? actualRoles[0] : 'ALL')
  return { role, switchRoles }
}

export function orderRoleFromPath(path: string): string | undefined {
  if (/^\/dashboard\/(?:my-orders|my-payments|my-invoices|my-certificates|my-refunds)(?:\/|$)/.test(path)) return 'CUSTOMER'
  if (path.startsWith('/dashboard/monthly-company')) return 'MONTHLY_ADMIN'
  for (const [prefix, role] of [['finance', 'FINANCE'], ['market', 'MARKET'], ['service', 'SERVICE']] as const) {
    if (path.startsWith(`/dashboard/${prefix}/`)) return role
  }
  const task = path.match(/^\/dashboard\/tasks\/([^/]+)/)?.[1]
  const roles: Record<string, string> = {
    assign: 'MARKET', 'invoice-approval': 'MARKET', 'payment-claim': 'MARKET',
    exception: 'MARKET', 'refund-approval': 'MARKET', 'reissue-approval': 'MARKET', 'voucher-assist': 'MARKET',
    dispatch: 'SERVICE', 'mail-receive': 'SERVICE', 'mail-dispatch': 'SERVICE', 'mail-return': 'SERVICE', 'outsource-testing': 'SERVICE', cert: 'SERVICE',
    'inspect-onsite': 'ENGINEER', 'inspect-mail': 'LAB_ENGINEER',
    'issue-invoice': 'FINANCE', 'voucher-audit': 'FINANCE', 'payment-reconcile': 'FINANCE', 'receipt-register': 'FINANCE', refund: 'FINANCE',
    monthly: 'MONTHLY_ADMIN', customer: 'CUSTOMER',
  }
  return task ? roles[task] : undefined
}

export type OrderDetailMode = 'staff' | 'customer' | 'check'
export function orderDetailTarget(href: string, origin: string) {
  try {
    const url = new URL(href, origin)
    if (url.origin !== origin) return null
    const match = url.pathname.match(/^\/dashboard\/(orders|my-orders|my-check\/order|(?:market|service|finance)\/orders)\/([^/]+)\/?$/)
    if (!match || ['new', 'create', 'public-pool', 'batch-import', 'assisted'].includes(match[2])) return null
    const orderId = decodeURIComponent(match[2])
    if (!/^[a-zA-Z0-9_-]+$/.test(orderId)) return null
    const mode: OrderDetailMode = match[1] === 'my-orders' ? 'customer' : match[1] === 'my-check/order' ? 'check' : 'staff'
    return { orderId, mode, role: orderRoleFromPath(url.pathname) }
  } catch { return null }
}

export function safeOrderReturn(value: string | null | undefined): string | null {
  if (!value || value.length > 4000 || !value.startsWith('/dashboard') || /[\\\r\n]/.test(value)) return null
  try {
    const url = new URL(value, 'https://local.invalid')
    if (url.origin !== 'https://local.invalid' || !/^\/dashboard(?:\/|$)/.test(url.pathname)) return null
    // A detail cannot be its own return host.
    if (orderDetailTarget(value, url.origin)) return null
    return url.pathname + url.search + url.hash
  } catch { return null }
}
